import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

type RequestDestroyAccess = {
    id: number;
    locationId: number;
};

const requests = {
    access: {
        destroy: (config: AxiosRequestConfig, url: RequestDestroyAccess) =>
            api.delete(
                `/backofficepayment/users/accesses/${url.id}/location/${url.locationId}`,
                config
            ),
        fetch: (config: AxiosRequestConfig, url: RequestUrlId) =>
            api.get(`/backofficepayment/users/accesses/${url.id}`, config),
        update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
            api.put(
                `/backofficepayment/users/accesses/${url.id}`,
                data,
                config
            ),
    },
    locations: {
        fetch: (config: AxiosRequestConfig) =>
            api.get(`/backofficepayment/locations/all`, config),
        roles: (config: AxiosRequestConfig, url: RequestUrlId) =>
            api.get(`/backofficepayment/locations/${url.id}/roles`, config),
    },
};

export default requests;
